import { Link, useParams } from 'react-router-dom';

// Compact, clickable progress rail shown at the top of every project screen.
// Replaces the old sidebar "Pipeline" list — the bid rolls Scope → Count → Bid,
// each step a single clear destination. Mapping/BOM/pricing are automatic and no
// longer separate stops the estimator has to visit.
const STEPS = [
  { key: 'scope', label: 'Scope & analyze', path: '' },
  { key: 'count', label: 'Count symbols', path: '/count' },
  { key: 'bid', label: 'Bid & proposal', path: '/outputs' },
] as const;

export type StepKey = (typeof STEPS)[number]['key'];

export function ProjectSteps({ current }: { current: StepKey }) {
  const { id = '' } = useParams();
  const idx = STEPS.findIndex((s) => s.key === current);
  return (
    <div className="steps">
      {STEPS.map((s, i) => (
        <Link
          key={s.key}
          to={`/projects/${id}${s.path}`}
          className={`step${i === idx ? ' step-active' : ''}${i < idx ? ' step-done' : ''}`}
        >
          <span className="step-num">{i < idx ? '✓' : i + 1}</span>
          <span>{s.label}</span>
        </Link>
      ))}
    </div>
  );
}
